import {fadeIn, fadeOut} from "./utils/common";

const addCloseModalsEvents = () => {
  const closeButtons: NodeListOf<HTMLElement> = document.querySelectorAll(`.js-modal-close`);

  const onCloseButtonClick = (evt: Event) => {
    const self = (evt.currentTarget as HTMLElement);
    if (self.dataset.closeTarget) {
      fadeOut(document.querySelector(self.dataset.closeTarget), 200);
    }
  };

  if (closeButtons.length) {
    closeButtons.forEach((button) => button.addEventListener(`click`, onCloseButtonClick));
  }
};

const addOpenModalsEvents = () => {
  const openButtons: NodeListOf<HTMLElement> = document.querySelectorAll(`.js-open-modal`);

  const onOpenButtonClick = (evt: Event) => {
    const self = (evt.currentTarget as HTMLElement);

    if (self.dataset.openTarget) {
      fadeIn(document.querySelector(self.dataset.openTarget), 200, `flex`);
    }
  };

  if (openButtons.length) {
    openButtons.forEach((button) => button.addEventListener(`click`, onOpenButtonClick));
  }
};

export {addCloseModalsEvents, addOpenModalsEvents};
